import VerificationCodeInput from '@helpers/helpComponents/VerificationCode';
import React, { useCallback } from 'react'
import { Animated } from 'react-animated-css';
import { Button, Card, Col, Container, Form, Image, Row } from 'react-bootstrap'
import { NotificationManager } from 'react-notifications';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

const particlesOptions = {
    fpsLimit: 60,
    particles: {
        number: {
            value: 100,
            density: {
                enable: true,
            },
        },
        color: {
            value: ["#ffcc00", "#ffffff", "#ff9900"],
        },
        opacity: {
            value: { min: 0.1, max: 0.6 },
        },
        size: {
            value: { min: 1, max: 3 },
        },
        move: {
            enable: true,
            speed: 4,
            random: false,
        },
    },
    interactivity: {
        detectsOn: "window",
        events: {
            onClick: {
                enable: true,
                mode: "push",
            },
            resize: true,
        },
    },
    background: {
        image: "url('https://globalclickmexico.com/img/loginNuevo.webp')",
        position: "50% 50%",
        size: "cover",
        repeat: "no-repeat",
    },
};

const validarCodigoAcceso = (codigo) =>{
    console.log('Codigo validado, ', codigo);
    NotificationManager.success("Codigo validado")
}

const CompetenciasLecturaVeloz = () => {

    //todo Desarrollar las 3 fases para la prueba:
    //*Primer evento de clasificatoria con un temporizador normal
    //*Segundo evento de clasificatoria con un contra reloj
    //*Evento de cierre del curso.
    
    const particlesInit = useCallback(async (engine) => {
            await loadFull(engine);
        }, []);
    return (

        <>
            <Particles options={particlesOptions} init={particlesInit} id="tsparticles" />
            <Animated animationIn="fadeIn" isVisible={true} className="vh-100">
                <div id="particles" className="h-100" style={{overflowY: "scroll"}}>
                    <Container className='d-flex h-100 justify-content-center flex-column align-items-center"'>
                        <Card style={{background: 'none'}} className="w-100 border-0">
                            <Row className="my-5 vh-50 gap-4" style={{ display: 'flex', flexDirection: "row", alignItems: 'center' }}>
                                <Col className='d-none d-lg-flex p-4  h-75 rounded' style={{ flexDirection: "row", alignItems: 'center' }}>
                                    <div>
                                       
                                        <span className='text-white' style={{fontSize: "25px"}}>Evento de competencias del curso:</span>
                                       
                                        <h2 className='text-white' style={{fontSize: "75px"}}>Comprensión y Lectura Inteligente</h2>

                                        <div className='d-flex flex-row justify-content-evenly gap-3 mt-5'>
                                            <Image src={require('@assets/images/logo-gc-horizontal.png')} alt="logo-uveg" width={150} />
                                            <Image src={require('@assets/images/uvegActualizado.png')} alt="logo-uveg" width={150} />
                                        </div>
                                    </div>
                                </Col>
                                <Col className='col-12 col-lg-6' style={{ display: 'flex', flexDirection: "row", alignItems: 'center' }}>
                                    <div>
                                        <div className='mb-4 d-block d-lg-none'>
                                            <div className='d-flex flex-row justify-content-center gap-3 mb-3'>
                                                <Image src={require('@assets/images/logo-gc-horizontal.png')} alt="logo-uveg" width={75} />
                                                <Image src={require('@assets/images/uvegActualizado.png')} alt="logo-uveg" width={75} />
                                            </div>
                                             <h4 style={{fontSize: "16px"}} className='text-white text-center'>Evento de competencias de Comprensión y Lectura Inteligente</h4>
                                        </div>
                                        <h2 className='text-white text-center' style={{fontSize: "25px"}} >Bienvenido al primer evento de calificación rumbo a la ceremonia de cierre del curso</h2>
                                        <Form className='w-100'>
                                                {/* <Form.Group>
                                                    <Form.Label className="text-white"><strong>Para comenzar escribe el código de acceso enviado a tu correo institucional</strong></Form.Label>
                                                    <Form.Control className="my-3" type='text' placeholder='Código de acceso' />
                                                </Form.Group> */}
                                                <h5 className='text-white text-center mb-4 mt-4 text-center'>Para comenzar escribe el código de acceso enviado a tu correo institucional</h5>
                                                <VerificationCodeInput
                                                length={4}
                                                onComplete={(code) => validarCodigoAcceso(code)}
                                                />

                                                {/* <div className='d-grid gap-2 mt-4'>
                                                    <Button className='btn-success'>
                                                        Comenzar
                                                    </Button>
                                                </div> */}
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Container>
                </div>
            </Animated>
            
        </>
    )
}

export default CompetenciasLecturaVeloz